import { Modal, Button } from 'react-bootstrap';
import CaseAuditTable from '../../case/audit/CaseAuditTable';
import { useGetQuadCaseAuditLogs } from '../../case/audit/useGetQuadCaseAuditLog';

export interface IQuadCaseAuditControlProps {
    cancelText: string;
    onCancel: () => void;
    onClose: () => void;
    open: boolean;
    params: {
        caseGuid: string;
    };
    showBackdrop?: boolean;
    title: string;
}

export function QuadCaseAuditControl(props: IQuadCaseAuditControlProps) {
    const caseAuditApi = useGetQuadCaseAuditLogs(props.params.caseGuid);

    return (
        <Modal centered show={props.open} backdrop={props.showBackdrop} size="xl" scrollable>
            <Modal.Header>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {caseAuditApi.isFetching || !caseAuditApi.data ? (
                    <>Loading...</>
                ) : (
                    <CaseAuditTable results={caseAuditApi.data} />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={props.onCancel}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
